// extracted by mini-css-extract-plugin
module.exports = {"card":"ul-z"};